import { defineStore } from 'pinia';
import { api as axios } from 'boot/axios';
import { ProductItem } from 'src/core/types/Products';
// import { LoaderStore } from 'stores/Loader/Loader';

// const loaderStore = LoaderStore();

export const PageStore = defineStore('Page', {
  state: (): {
    content: ProductItem | any;
    currentRoute: string | null;
    head: any;
    header: any;
    breadcrumbs: { name: string; link: string }[];
    sidebar: any;
    footer: any;
  } => ({
    currentRoute: null,
    head: {},
    header: {},
    breadcrumbs: [],
    content: {},
    sidebar: {},
    footer: {},
  }),
  actions: {
    async getPage(link: string, query: any = null) {
      // loaderStore.loaderActive();
      if (query) {
        query = new URLSearchParams(query).toString();
      }

      const linkPath = link === '*' ? '/' : link;
      const req = await axios.get(`?link=${linkPath}&${query}`);
      
      if (req.data.data.content === 404) {
        this.currentRoute = req.data.data.content;
      } else {
        this.currentRoute = req.data.data.type || 'Page';
      }

      const { head, header, breadcrumbs, content, sidebar, footer } = req.data.data;

      this.head = head || null;
      this.header = header || null;
      this.breadcrumbs = breadcrumbs || null;
      this.content = content || null;
      this.sidebar = sidebar || null;
      this.footer = footer || null;

      // loaderStore.loaderDisable();
    },
  },
});
